import Swiper, { Navigation, Pagination, Keyboard } from "swiper";

const componentSlider = () => {
	const slidermitglieder = new Swiper(".slidermitglieder", {
		modules: [Navigation, Pagination, Keyboard],
		// loop: true,
		centeredSlides: true,
		// slidesPerView: "auto",
		// slidesPerView: 1,
		slidesPerView: 1.4,
		spaceBetween: 5,
		preloadImages: true,
        // simulateTouch: false,
		threshold: 10,
		breakpoints: {
			400: {
				slidesPerView: 1.5,
                spaceBetween: 10,
			},
            540: {
				slidesPerView: 2,
                spaceBetween: 20,
			},
			768: {
				slidesPerView: 3,
                spaceBetween: 20,
			}
		},
		keyboard: {
            enabled: true,
            onlyInViewport: true,
        },
		pagination: {
			el: ".slidermitglieder__pagination",
			clickable: true,
		},
		navigation: {
			nextEl: ".slidermitglieder__next",
			prevEl: ".slidermitglieder__prev",
		},
	});
};

export default componentSlider;
